import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import {
	Box,
	Button,
} from '@chakra-ui/react'
import { fetchWrapper } from '../../helpers';
import { InputText, Form } from '../../components/form'
import { toast } from "react-toastify";


function SdkUrl() {
	const [list, setList] = useState({})
	const FormSchema = Yup.object().shape({
		value: Yup.string().required('Required'),

	});
	const [formData, setFormData] = useState({
		value: list.value,


	});


	useEffect(() => {
		loadList();
	}, [])



	const loadList = async () => {
		const url = `${process.env.REACT_APP_API_URL}/setting/by-id?key=sdk_url`;
		const data = await fetchWrapper.get(url)

		if(data.data){
			setList(data.data);
			setFormData({
				value: data.data.value,
			});
		}
	}


	const onSubmit = async (values, { setSubmitting, resetForm, setStatus }) => {
		let data = {
			key: 'sdk_url',
			...values
		}

		const url = `${process.env.REACT_APP_API_URL}/setting/create`;
		await fetchWrapper.post(url, data)
		loadList();
		toast(`Record has been saved `, {
			type: "info"
		});
		// resetForm()
	}

	return (

		<div className="setting_detail_section">
			<Box mb="20px">
				<h2 className="main_heading">SDK URL</h2>
			</Box>
			<Form
				enableReinitialize
				validationSchema={FormSchema}
				initialValues={formData}
				onSubmit={onSubmit}
			>

				<Box mb="10px" w="40%">
					<InputText name="value" title="SDK URL" inputProps={{ isRequired: true }} placeholder="Please Enter Sdk URL"/>
				</Box>
				<Button py="10px" px="25px" color="#fff" bg="#2563eb" fontSize="14px" fontWeight="500" fontFamily="'Open Sans', sans-serif"
					mb={4}

					type='submit'
				>
					Update
				</Button>
			</Form>
		</div>


	);
}

export default SdkUrl;